import { render } from "./community.vue?vue&type=template&id=8a2e4b4a"
import script from "./community.vue?vue&type=script&lang=js"
export * from "./community.vue?vue&type=script&lang=js"

import "../forum/css/antd.css?vue&type=style&index=0&lang=css"
import "./community.vue?vue&type=style&index=1&id=8a2e4b4a&lang=css"

import exportComponent from "D:\\SVNwork\\01_工程区\\01_代码\\RPAPortal\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__